import { render, staticRenderFns } from "./Dept.vue?vue&type=template&id=0d1c2e77&scoped=true&lang=pug"
import script from "./Dept.vue?vue&type=script&lang=js"
export * from "./Dept.vue?vue&type=script&lang=js"
import style0 from "./Dept.vue?vue&type=style&index=0&id=0d1c2e77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c2e77",
  null
  
)

export default component.exports